__webpack_require__.p = "https://documents.mubs.ac.ug/";